module.exports = __webpack_public_path__ + "img/aviation-support.3cd63a29.png";